import { defineComponent as h, computed as i, useAttrs as r, inject as c, ref as w, watch as y, onMounted as k, openBlock as d, createBlock as B, unref as C, mergeProps as g, withCtx as T, createElementVNode as u, normalizeClass as A, toDisplayString as N, createElementBlock as E, renderSlot as I, createCommentVNode as K } from "vue";
import "@ds/components/Badge";
import { RevButtonBase as R } from "@ds/components/ButtonBase";
import { variantKey as S, setActiveTabKey as V } from "@ds/components/Tabs";
import { useTrackedListeners as $ } from "../../composables/useTrackedListeners.js";
import { tw as t } from "../../utils/tailwind.js";
const j = {
  key: 0,
  class: "ml-8 align-middle"
}, G = /* @__PURE__ */ h({
  name: "RevTabItem",
  inheritAttrs: !1,
  __name: "TabItem",
  props: {
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: {}
  },
  emits: ["click"],
  setup(l, { emit: f }) {
    const e = l, m = f, v = i(() => {
      const { listeners: a } = $(e);
      return {
        ...r(),
        ...a,
        class: void 0
      };
    }), n = c(S), o = c(V), s = w(null), b = i(() => [
      t`focus-visible-outline-inset-hi relative flex list-none items-center`,
      n === "fixed" && t`flex-1`,
      n === "flexible" && t`whitespace-nowrap`
    ]), p = i(() => [
      r().class,
      t`h-56 content-center border-none bg-transparent p-0 text-center no-underline motion-safe:transition motion-safe:duration-200`,
      !e.active && !e.disabled && t`text-action-default-low cursor-pointer hover:bg-static-default-min-hover hover:text-action-default-low-hover`,
      e.active && !e.disabled && t`text-action-default-low-pressed pointer-events-none cursor-default`,
      e.active && t`body-1-bold`,
      !e.active && t`body-1`,
      e.disabled && t`text-action-default-low-disabled cursor-not-allowed`,
      n === "fixed" && t`line-clamp-2 flex-1 grow px-12`,
      n === "flexible" && t`overflow-hidden text-ellipsis`
    ]), x = (a) => {
      e.disabled || m("click", a);
    };
    return y(
      () => e.active,
      async (a) => {
        a && o && s.value && o(s.value);
      }
    ), k(async () => {
      e.active && o && s.value && o(s.value);
    }), (a, z) => (d(), B(C(R), g(v.value, {
      "aria-selected": l.active,
      class: b.value,
      disabled: l.disabled,
      role: "tab",
      title: l.label,
      onClick: x
    }), {
      default: T(() => [
        u("span", {
          ref_key: "tab",
          ref: s,
          class: A(p.value)
        }, [
          u("span", null, N(l.label), 1),
          a.$slots.default ? (d(), E("span", j, [
            I(a.$slots, "default")
          ])) : K("", !0)
        ], 2)
      ]),
      _: 3
    }, 16, ["aria-selected", "class", "disabled", "title"]));
  }
});
export {
  G as default
};
